module.exports = __webpack_public_path__ + "static/media/01_design_agd-abstrack-logo.b2f905b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-abstrack-logo.jpg
// module id = 49
// module chunks = 0